import React from 'react';
import { isIOS, isSafari } from 'react-device-detect';
import { Box } from '@mui/material';
import PortraitPaperLayout from '../@common/portrait/PortraitPaperLayout';
import { SmallPageLineText } from '../@common/PageLineText';
import GroupedPageLines from '../@common/GroupedPageLines';
import PortraitPageLines from '../@common/portrait/PortraitPageLines';
import BaseInput from '../@common/BaseInput';
import { WorksheetBaseProps } from '../@types';
import NameAndDateLines from '../@common/NameAndDateLines';
import { determineStyleBasedOnLineWidth, getFontSize } from 'utils/style-utils';
import { translate } from '../../translations/translator';
// Print styles are now handled globally in _print.scss
const t = key => translate('worksheet', key);

type VocabularyProps = WorksheetBaseProps & {
  value: string;
  isCursive?: boolean;
  isNarrow?: boolean;
  valueMap?: any;
};

const Vocabulary = ({ onChange, isCursive, isNarrow, valueMap, printRef }: VocabularyProps) => {
  const bookFont = isCursive ? 'Cursive-Book' : 'Print-Wide-Book';

  const marginTop = determineStyleBasedOnLineWidth(isCursive, isNarrow, {
    cursiveAndNarrow: isSafari || isIOS ? '-10px' : '-22px',
    narrow: isIOS ? '-16px' : '-17px',
    cursive: isSafari || isIOS ? '-15px' : '-32px',
    regular: '-28px'
  });
  const fontSize = getFontSize(isCursive, isNarrow);
  const numOfLines = isNarrow ? 7 : 4;
  const portraitLines = [...Array(numOfLines).keys()];
  const marginTopContent = isNarrow ? '65px' : '-100px';

  const handleChange = (key, value) => {
    onChange({
      [key]: value
    });
  };

  const baseInputStyles: any = {
    fontFamily: bookFont,
    color: '#000',
    style: {
      fontSize: fontSize,
      width: 325,
      marginLeft: 10,
      marginTop: marginTop,
      color: '#000'
    }
  };

  return (
    <PortraitPaperLayout isNarrow={isNarrow} printRef={printRef}>
      <NameAndDateLines
        isCursive={isCursive}
        fontFamily={bookFont}
        isNarrow={isNarrow}
        top={isNarrow ? 10 : -70}
        width={775}
      />
      <Box sx={{ marginTop: marginTopContent, listStyle: 'none' }} component={'ul'}>
        {portraitLines.map(x => (
          <>
            <PortraitPageLines
              isNarrow={isNarrow}
              repeatLines={false}
              singleColumn
              rowPadding={isNarrow ? '0px 32px 32px 10px' : '70px 16px 20px 16px'}
              rowMargin={isNarrow ? '5px 15px 15px 15px' : '70px 15px 40px 15px'}
              col1={
                <li>
                  <SmallPageLineText isNarrow={isNarrow}>
                    <div style={{ marginLeft: '-15px' }}>{x + 1}.</div>
                    <BaseInput
                      onChange={({ target }) => handleChange(x + 1, target.value)}
                      showBackground={true}
                      {...baseInputStyles}
                      placeholder={t('word')}
                      maxLength={30}
                      fontSize={65}
                      value={valueMap[x + 1]}
                      aria-label={`${t('word')} ${x + 1}`}
                    />
                  </SmallPageLineText>
                </li>
              }
            />
            <GroupedPageLines
              marginPageLines={isNarrow ? '60px 45px 0px 25px' : '-13px 50px 0px 40px'}
              isNarrow={isNarrow}
              top={isNarrow ? -45 : 40}
              width={isNarrow ? 700 : 750}
            />
          </>
        ))}
      </Box>
    </PortraitPaperLayout>
  );
};

export default Vocabulary;
